import React, { useEffect, useRef } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";
import "lenis/dist/lenis.css";

const SmoothScroll = ({ children, isChatOpen }) => {
  const lenisRef = useRef(null);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      autoRaf: true,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false, // Disable smooth scroll on touch devices for native feel and to fix flickering
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;

    return () => {
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) {
      if (isChatOpen) {
        lenisRef.current.stop();
      } else {
        lenisRef.current.start();
      }
    }
  }, [isChatOpen]);

  useEffect(() => {
    if (hash && lenisRef.current) {
      // Small delay to ensure the page has rendered and the section exists
      setTimeout(() => {
        lenisRef.current.scrollTo(hash, { offset: 0, duration: 1.5 });
      }, 100);
    } else if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    }
  }, [pathname, hash]);

  return <>{children}</>;
};

export default SmoothScroll;
